<accredible-form-section-component
  *transloco="let t; read: 'marketing-content-settings'"
  [title]="t('title')"
  [description]="t('description')">
  <div class="marketing-content-wrapper">
    <div class="left-content">
      @if (marketingContent$ | async; as marketingContent) {
        @for (content of marketingContent; track content.id) {
          <div class="marketing-content-item">
            <div class="content-info">
              <div class="font-normal-semibold">
                {{ t(content.content_type) }}
              </div>
              <div class="content-status font-s-semibold" [class.active]="content.visible">
                {{ content.visible ? t('active') : t('inactive') }}
                <span class="font-s-regular">
                  -
                  {{
                    t('last_updated', {
                      date:
                        content.updated_at | localeDate: 'dd MMM YYYY' : (languageCode$ | async),
                    })
                  }}
                </span>
              </div>
            </div>

            <div class="marketing-content-actions">
              <button
                accredible-button-outline
                size="small"
                icon="chevron-right"
                data-cy="btn-view-manage-marketing-content"
                [embeddingRouterLink]="'/directories/' + directoryId() + '/marketing-content'"
                [embeddingHrefUrl]="
                  '/issuer/dashboard/directories/' + directoryId() + '/marketing-content'
                ">
                {{ t('view_manage') }}
              </button>
            </div>
          </div>
        }
      } @else {
        <accredible-icon icon="announcement" />

        <div class="title font-normal-semibold">{{ t('empty_state.title') }}</div>

        <div class="description font-s-regular">{{ t('empty_state.description') }}</div>
      }

      <a
        accredible-button-outline
        size="small"
        icon="plus"
        data-cy="btn-add-marketing-content"
        [attr.disabled]="(marketingContent$ | async)?.length >= 3"
        [embeddingRouterLink]="'/directories/' + directoryId() + '/marketing-content'"
        [embeddingHrefUrl]="
          '/issuer/dashboard/directories/' + directoryId() + '/marketing-content'
        ">
        {{ t('add_marketing_content') }}
      </a>
    </div>

    <div class="right-content">
      <img src="assets/images/marketing-content/branding-package.svg" alt="" />
    </div>
  </div>
</accredible-form-section-component>
